"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  r = require("prop-types"),
  a = require("classnames"),
  n = require("./taggedTemplateLiteral-97b463ad.js"),
  t = require("styled-components"),
  l = require("polished/lib/helpers/rem");
function o(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var s,
  i,
  c,
  d,
  g = o(e),
  u = o(r),
  m = o(a),
  p = o(t),
  b = o(l),
  f = p["default"].div(s || (s = n._taggedTemplateLiteral(["\n  height: ", ";\n  overflow: hidden;\n"])), b["default"](6)),
  h = p["default"].progress(i || (i = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var r,
      a,
      l = e.branding,
      o = e.theme,
      s = e.themeType;
    "nm" === l && ("lightTheme" === s ? (r = o.colors.action.lightTheme.ctaBgSecondaryHover, a = o.colors.blue.blueLight2) : "darkTheme" === s && (r = o.colors.action.darkTheme.ctaBgSecondaryHover, a = o.colors.sky.sky)), "pcg" === l && (r = o.colors.brand.pcg.gray, a = o.colors.brand.pcg.gold1);
    return t.css(d || (d = n._taggedTemplateLiteral(["\n      ", " /** Default = Primary Light Theme */\n    "])), t.css(c || (c = n._taggedTemplateLiteral(["\n      width: 100%;\n      background-color: ", ";\n      border: none;\n      appearance: none;\n      &::-moz-progress-bar {\n        background-color: ", ";\n        transition: all 1s;\n      }\n      &::-moz-appearance {\n        background-color: ", ";\n      }\n      ::-webkit-progress-bar {\n        background-color: ", ";\n      }\n      ::-webkit-progress-value {\n        background-color: ", ";\n        transition: all 1s;\n      }\n      color: blue;\n    "])), r, a, r, r, a));
  }),
  T = function T(e) {
    var r = e.branding,
      a = e.className,
      n = e.fillPercentage,
      t = e.labelText,
      l = e.themeType;
    return g["default"].createElement(f, {
      className: m["default"]("nmx-no-print", a)
    }, g["default"].createElement("label", null, " ", t, g["default"].createElement(h, {
      branding: r,
      className: "nmx-progress-bar",
      max: "100",
      themeType: l,
      value: n
    })));
  };
T.propTypes = {
  branding: u["default"].oneOf(["nm", "pcg"]),
  className: u["default"].string,
  fillPercentage: u["default"].number.isRequired,
  labelText: u["default"].string,
  themeType: u["default"].oneOf(["lightTheme", "darkTheme"])
}, T.defaultProps = {
  branding: "nm",
  fillPercentage: 0,
  themeType: "lightTheme"
}, exports.ProgressBarComponent = T;